const A6aResponseApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/response/cusres/get`,
    POST: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/response/cusres`,
    GET_D4: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/d4notice/get`,
    POST_D4: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/d4notice/create`
  };
  
  export default A6aResponseApiUrls;